<template>
  <b-container>
    <!-- <h5 class="mt-3">Manage Service Request</h5> -->
    <div class="mt-3">
          <div v-if="detailall.status == 6 " class="after-close">
            <div class="d-inline-block" v-if="user.userLevel == 50 && detailall.status == 6">
              <div class="btn-fix-skyblue cr-pointer" @click="sumaryModal = true" v-if="detailall.summary != '' && typeof detailall.summary != 'undefined'">
                Summary by company
              </div>
              <div class="btn-fix-orange cr-pointer" @click="reviewModal = true" v-if="typeof detailall.conclusion == 'undefined' && checkComment(user.userId) == false">
                Review
                
              </div>
            </div>
            <div v-if="user.userLevel == 0 && detailall.status == 6">
              <div class="btn-fix-skyblue cr-pointer" @click="conclusionModal = true" v-if="detailall.conclusion != '' && typeof detailall.conclusion != 'undefined'">
                Conclusion by Mentor 
              </div>
              <div class="btn-fix-orange cr-pointer" @click="writeSumaryModal = true" v-if="typeof detailall.summary == 'undefined'" >
                Write summary
              </div>
            </div>
          </div>
            <b-breadcrumb @click="gopath()"  :items="items"></b-breadcrumb>
           
             <b-col cols="12">
                 <b-row class="d-flex justify-content-end">
              <b-col cols="12" sm="6" v-if="user.userLevel == 50">
                <b-row>
                  <b-col cols="5" sm="4" class="bgtopic hearder-middle" style="border-radius:0px;border-top-left-radius:3px;">
                 <span class="red"> <strong style="font-weight: lighter;"> Severity:  {{ convertseverity(detailall.severityStatus)}}</strong></span> 
                  </b-col>
                   <b-col cols="7" sm="8" class="bgtopic hearder-middle" style="color:#585858;border-radius:0px">
                     <strong style="font-weight: lighter;">Type of business: {{detailall.industry}}</strong>
                   </b-col>
                  </b-row>
              </b-col>
               <b-col cols="12" sm="6">
                  <b-row>
                  <b-col cols="5"  class="bgtopic hearder-middle" style="color:#585858;border-radius:0px;" 
                  :class="{'radius-btn':user.userLevel == 0}">
                    <strong style="font-weight: lighter;">Ticket no. {{detailall.ticketNo}}</strong>
                  </b-col>
                   <b-col cols="7" class="bgtopic hearder-middle" style="color:#585858;border-radius:0px;border-top-right-radius: 3px;" >
                     <strong style="font-weight: lighter;">Last updated: {{detailall.updateDate ? covertime2(detailall.updateDate) : covertime2(detailall.createDate)}}</strong>
                   </b-col>
                  </b-row>
               </b-col>
                 </b-row>
         </b-col>
       <b-container  class="bv-example-row mb-3 py-3 detail radius-top-none" style="margin-top:1px;">
      <h5 style="font-weight:bold" >{{ detailall.topic}}</h5>
       <b-row>
           <b-col cols="12" sm="2" class="text-center pd-y-3">
              <div v-if="getProfilePic(detailall.typeSystem) != ''&& comapanyName.profilePic != null && comapanyName.profilePic != '' && typeof comapanyName.profilePic != 'undefined'" class="profilePic">
                <img :src="getProfilePic(detailall.typeSystem)+comapanyName.profilePic">
              </div>
              <div v-else class="profilePic">
                  <img src="@/assets/img/user.png">
                </div>
           </b-col>
           <b-col cols="12 blea text-break" sm="10">
              <h4 class=""> <strong>{{detailall.subject}} </strong></h4>
              <h6 class="grey py-1 font-italic font-14">Created date: {{ covertime2(detailall.createDate)}}</h6>
                <span class="text-center" >
                  <!-- <b-button class="CLOSED font-14" v-if="detailall.status == 6">CLOSED</b-button>
                  <b-button class="OPEN font-14" v-if="detailall.status == 1">OPEN</b-button>
                  <b-button class="ONHOLD font-14" v-if="detailall.status == 2">ON HOLD</b-button>
                  <b-button class="COMPANY-REPLY font-14" v-if="detailall.status == 3">COMPANY-REPLY</b-button>
                  <b-button class="ANSWERED font-14" v-if="detailall.status == 4" >ANSWERED</b-button> -->
                    <b-button class="CLOSED status-btn" v-if="detailall.status == 6" ><span class="font-14 css-btn">CLOSED</span></b-button>
                    <b-button class="OPEN status-btn" v-if="detailall.status == 1" ><span class="font-14 css-btn">OPEN</span></b-button>
                    <b-button class="ONHOLD status-btn" v-if="detailall.status == 3" ><span class="font-14 css-btn">ONHOLD</span></b-button>
                    <b-button class="COMPANY-REPLY status-btn" v-if="detailall.status == 5"><span class="font-14 css-btn">COMPANY-REPLY</span></b-button>
                    <b-button class="ANSWERED status-btn"  v-if="detailall.status == 2"><span class="font-14 css-btn">ANSWERED</span></b-button>
                    <b-button class="inprocress status-btn"  v-if="detailall.status == 4"><span class="font-14 css-btn">IN-PROCESS</span></b-button>
                </span>
                <span class="text-dark-grey font-14 font-weight-bold"><i class="fas fa-suitcase"></i> {{detailall.category}}</span>
              <hr/>
              <span class="font-16">
                <strong>{{ detailall.detail }}</strong>
              </span> 
              <div class="mt-4 mb-4" v-for="(val2,index) in detailall.postFile" :key="index" v-if="val2.fileName != null">Attached : 
                    <span> 
                     <a target="_bank" :href="pathFile+val2.fileName"> {{ val2.fileName}} </a>
                     </span>
              </div>
           </b-col>
       </b-row>
      </b-container>
    </div>
    <!--  -->

    <!-- comment new -->
    <div  class="mt-4 bg-light" v-for="(val,index) in detailall.comments" :key="index">
      
      <!-- แก้ด้วย -->
      <b-container :class="{bgowner: val.name != user.name }" class="bv-example-row mb-3 py-3 detail text-break">
       <b-row>
           <b-col cols="12" sm="2" class="text-center pd-y-3">
              <div v-if="getProfilePic(val.typeSystem) != ''" class="profilePic">
                <img :src="getProfilePic(val.typeSystem)+val.profile">
              </div>
              <div v-else>
                <img src="@/assets/img/user.png">
              </div>
                 
           </b-col>
           <b-col cols="12" sm="10">
              <h4 style="display:inline-block" > <strong>{{val.name}} {{val.surname}}</strong> </h4> 
              <b-badge v-if="val.userLevel == 50" pill variant="primary" class="mentorpill"  style="display:inline-block;position: relative; top: -5px;">
                 <strong>MENTOR</strong>
                </b-badge> 
                <b-badge v-if="val.userLevel == 0" pill variant="primary"  class="companypill" style="display:inline-block;position: relative; top: -5px;">
                 <strong>COMPANY</strong>
                </b-badge>
              <h6 style="font-size:14px" class="grey mb-1 mt-1">Created date: {{ covertime2(val.createDate)}}</h6>

              <hr/>
              <span style="font-size:15px">
                <strong style="font-weight: lighter;">{{ val.message }}</strong>
              </span> 
              <div class="mt-4 mb-4" v-if="val.commentFile.length > 0 && val.commentFile[0].fileName != null">Attached : 
                    <span v-for="(val2,index) in val.commentFile" :key="index"> 
                     <a target="_bank" :href="pathComment+val2.fileName"> {{ val2.fileName | snippetmoreMid}} </a>
                     </span>
              </div>
              <h6 class="mt-2 text-right" v-if="val.userLevel > 0 && user.userLevel == 0">
                You rated this response: <span v-for="(data,key) in 5" @click="yourRate[key] = key+1,Addrate(key+1,val._id,val.ownedBy)" class="mr-2 cr-pointer" :key="key"><i class="fas fa-star" :class="(detailall.ownedPostBy == user.userId && val.score >= (key+1))  ? 'text-orange' : 'text-muted'"></i></span>
              </h6>
           </b-col>
       </b-row>
      </b-container>
       </div>
   
      <div class="mt-3 mb-5 bg-light " >
       <b-container class="bv-example-row mb-3 py-3 detail relative">
        <div class="status-close"></div>
        <b-row>
           <b-col class="text-left" cols="12" >
             <b-row v-if="detailall.status != 6">
                <b-col class="text-center pd-y-3" cols="12" sm="2">
                  <div v-if="getProfilePic(user.typeSystem) != ''" class="profilePic">
                    <img :src="getProfilePic(user.typeSystem)+user.profilePic">
                  </div>
                  <div v-else class="profilePic">
                      <img src="@/assets/img/user.png">
                </div>
                </b-col>
                <b-col cols="12" sm="10">
                <h4 style="display:inline-block" > <strong>{{user.name}} {{user.surname}}</strong> </h4>
                 <b-badge v-if="user.userLevel == 50" pill variant="primary" class="mentorpill"  style="display:inline-block;position: relative; top: -5px;">
                 <strong>MENTOR</strong>
                </b-badge> 
                <b-badge v-if="user.userLevel == 0" pill variant="primary"  class="companypill" style="display:inline-block;position: relative; top: -5px;">
                 <strong>COMPANY</strong>
                </b-badge> 
                    <b-form-textarea
                    :disabled="detailall.status == 6 ? true : false"
                     class="my-2 "
                     :class="{'opacity-commet':detailall.status == 6}"
                      id="textarea"
                      v-model="comment"
                      placeholder="Your Comment..."
                      rows="5"
                      max-rows="5"
                    ></b-form-textarea>

                    <div class="my-2" :class="{'opacity-commet':detailall.status == 6}">
                      <h6><strong>Attachments:</strong>  
                        <span class="grey">
                          (Allowed File Extensions: .jpg, .gif, .jpeg, .png)
                        </span>
                      </h6>
                      <div v-for="(val,index) in file" :key="index" class="d-flex align-items-center my-2">
                        <b-form-file 
                          :disabled="detailall.status == 6 ? true : false"
                          class="col-11 col-sm-7"
                          type="file"
                          v-model="file[index].fileName"
                          placeholder="Choose a file..."
                          @change="uploadFile($event,index)"
                          drop-placeholder="Drop file here..."
                          ></b-form-file>
                          <b-col md="1" align-self="center" class="p-0 ml-3 my-2" v-if="file.length >1">
                            <label class="text-danger cr-pointer" @click="cancel(file.length-1)"><i class="fas fa-minus-circle"></i></label>
                          </b-col>
                          <!-- <span v-if="index > 0" class="ml-2 text-danger" @click="delFile(index)"><i class="fas fa-minus-circle"></i></span> -->
                      </div>
                        <!-- <b-form-file  :file-name-formatter="formatNames"> -->
                      <div class="my-2 orange cr-pointer" >
                        <span @click="addmorefile" class="mr-2"><font-awesome-icon icon="plus-circle"  /> Add More</span>
                        <!-- <span class="text-danger" ><i class="fas fa-times-circle"></i> Cancel</span>  -->
                      </div>

                        <h6 v-if="user.userLevel > 0"><strong>Status Ticket </strong>  
                          <b-form-select  name="statusRq" v-validate="'required'" :disabled="detailall.status == 6 ? true : false"  v-model="statusticket" :options="optionstatus" 
                          :class="[(widthMax < 576)?'col-8':'col-5 ml-2',{'is-validate':errors.has('statusRq')}]"
                          ></b-form-select>
                        
                          <div v-show="errors.has('statusRq')" class="pt-3 text-danger">
                              Please select status ticket.
                          </div>
                        </h6>
                          <!--  -->
                        <!-- <h6 class="info"> Allowed File Extensions: .jpg, .gif, .jpeg, .png </h6> -->
                        <!-- uploadfile_comment -->
                        <!-- @click="submit()" -->
                        <div class="my-4 tCenter">
                          <b-button :disabled="detailall.status == 6 ? true : false" @click="submit()" class="reply my-1" variant="primary">Reply</b-button>
                          <b-button :disabled="detailall.status == 6 ? true : false" class="closeticket my-1" @click="modalClose = true" variant="primary" >CLOSE TICKET</b-button>
                        </div>
                    </div>
                 </b-col>
                 
             </b-row>
             <b-row v-else>
                <b-col cols="12" >
                  <div class="p-5 text-center">
                    <b-button :disabled="detailall.status == 6 ? true : false" class="closeticket" @click="closeTicket()" variant="primary" >CLOSED</b-button>
                  </div>
                  
                 </b-col>
              </b-row>
          </b-col>
       </b-row>
      </b-container>
    </div>
     <vue-element-loading :active="loading" :is-full-screen="true"/> 
      <b-modal v-model="modalservice" hide-header hide-footer id="modal-1" size="lg">
        <b-container>
        <div class="d-flex justify-content-between mt-4" style="position:relative">
     
        <h2 class="abcenter text-center w-100"><strong>Review</strong></h2>
        <i @click="modalservice = !modalservice" class="fas fa-times"></i>
        </div>

        <h6  class="mt-4 "><strong>Mentor </strong >{{mentorName}}</h6>

        <h6  class="mt-2"><strong>Category </strong>{{detailall.category}}</h6>
          <!-- <h5 class="float-left">New Service Request  </h5>    <b-badge class="float-left" pill variant="primary"></b-badge> -->
        <h6 class="mb-1 mt-3"><strong>Title</strong> </h6>
        <b-form-input v-model="dataReview.review.title" placeholder="Title"></b-form-input>
          <h6 class="mb-1 mt-3"><strong>Details :</strong> </h6>
          <b-form-textarea
          id="textarea"
          v-model="dataReview.review.detail"
          placeholder=""
          rows="6"
          max-rows="6"
          ></b-form-textarea>
           <h6 class="mb-1 mt-3"><strong>Rating : <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" class="mr-2"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1) ? 'text-orange' : 'text-muted'"></i></span> </strong>
          </h6>
          <p class="text-danger" v-if="validateRate == true">Please rate your mentor</p>
          <h6 class="mb-1 mt-3"><strong>Review by <span>{{user.name}} </span>
              <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span></strong> </h6>
            <div>
             
            </div>
          <div class="mt-3 d-flex justify-content-center">
             <b-button @click="submitReview()" class="pr-5 pl-5">SUBMIT</b-button>
          </div> 
        </b-container>
      </b-modal>

      <b-modal v-model="modalClose" hide-header hide-footer id="modal-1" size="lg">
        <b-container>
        <div class="d-flex justify-content-between mt-4" style="position:relative">
          <h2 class="abcenter text-center w-100"><strong>Comfirm</strong></h2>
          <i @click="writeSumaryModal = !writeSumaryModal" class="fas fa-times"></i>
        </div>
        <h4 class="mb-1 mt-3 text-center"><strong>You want to close ticket ?</strong></h4>
        <div class="mt-4 d-flex justify-content-center">
           <button @click="closeTicket(),modalClose = false" class="px-5 mx-2 btn btn-success">Yes</button>
           <button class="px-5 mx-2 btn btn-danger" @click="modalClose = false">No</button>
        </div> 
        </b-container>
      </b-modal>


      <b-modal v-model="writeSumaryModal" hide-header hide-footer id="modal-1" size="lg">
        <b-container>
        <div class="d-flex justify-content-between mt-4" style="position:relative">
          <h2 class="abcenter text-center w-100 fz-mobile"><strong>Write summary</strong></h2>
          <i @click="writeSumaryModal = !writeSumaryModal" class="fas fa-times"></i>
        </div>
        <h6 class="mb-1 mt-3"><strong>Write summary to see mentor’s summary.</strong> </h6>
          <b-form-textarea
          id="textarea"
          v-model="sumaryText"
          placeholder=""
          rows="6"
          max-rows="6"
          ></b-form-textarea>
          <div class="mt-3 d-flex justify-content-center">
             <b-button @click="addConclution()" class="pr-5 pl-5">SUBMIT</b-button>
          </div> 
        </b-container>
      </b-modal>


      <b-modal v-model="reviewModal" hide-header hide-footer id="modal-1" size="lg">
        <b-container>
        <div class="d-flex justify-content-between mt-4" style="position:relative">
          <h2 class="abcenter text-center w-100 fz-mobile"><strong>Write a conclusion.</strong></h2>
          <i @click="reviewModal = !reviewModal" class="fas fa-times"></i>
        </div>
        <h6 class="mb-1 mt-3"><strong>Write a conclusion to get comapany’s review.</strong> </h6>
          <b-form-textarea
            id="textarea"
            v-model="conclusionText"
            placeholder=""
            rows="6"
            max-rows="6"
          ></b-form-textarea>
          <div class="mt-3 d-flex justify-content-center">
             <hr>
          </div> 
        </b-container>
        <b-container>
        <div class="d-flex justify-content-between mt-4" style="position:relative">
          <h2 class="abcenter text-center w-100 fz-mobile"><strong>Review</strong></h2>
        </div>
        <h6  class="mt-4 "><strong>Company </strong>{{comapanyName.name}} {{comapanyName.surname}}</h6>
        <h6  class="mt-2"><strong>Category </strong>{{detailall.category}}</h6>
          <!-- <h5 class="float-left">New Service Request  </h5>    <b-badge class="float-left" pill variant="primary"></b-badge> -->
        <h6 class="mb-1 mt-3"><strong>Title</strong> </h6>
        <b-form-input v-model="dataReview.review.title" placeholder="Title"></b-form-input>
          <h6 class="mb-1 mt-3"><strong>Details :</strong> </h6>
          <b-form-textarea
          id="textarea"
          v-model="dataReview.review.detail"
          placeholder=""
          rows="6"
          max-rows="6"
          ></b-form-textarea>
           <h6 class="mb-1 mt-3"><strong>Rating : <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" class="mr-2"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1)  ? 'text-orange' : 'text-muted'"></i></span> </strong>
          </h6>
          <p class="text-danger" v-if="validateRate == true">Please rate your company</p>
          <h6 class="mb-1 mt-3"><strong>Review by <span>{{user.name}} </span>
              <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span></strong> </h6>
          <div class="mt-3 d-flex justify-content-center mb-4">
             <b-button @click="reviewCompany()" class="pr-5 pl-5">SUBMIT</b-button>
          </div> 
        </b-container>
      </b-modal>

    
      <b-modal v-model="sumaryModal" hide-header hide-footer id="modal-1" size="lg">
        <b-container>
        <div class="d-flex justify-content-between mt-4" style="position:relative">
          <h2 class="abcenter text-center w-100"><strong>Sumary by company</strong></h2>
          <i @click="sumaryModal = !sumaryModal" class="fas fa-times"></i>
        </div>
          <div class="mt-3">
            {{detailall.summary}}
          </div> 
        </b-container>
      </b-modal>

      <b-modal v-model="conclusionModal" hide-header hide-footer id="modal-1" size="lg">
        <b-container>
        <div class="d-flex justify-content-between mt-4" style="position:relative">
          <h2 class="abcenter text-center w-100 fz-mobile"><strong>Conclusion by Mentor</strong></h2>
          <i @click="conclusionModal = !conclusionModal" class="fas fa-times"></i>
        </div>
          <div class="mt-3">
            {{detailall.conclusion}}
          </div> 
        </b-container>
      </b-modal>


   </b-container >
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import {HTTPTICKET,HTTPMentor,HTTPDynamic,HTTPReview} from "@/axios";
import Swal from 'sweetalert2'

export default {
  name: 'HelloWorld',
  data () {
    return {
      widthMax: window.innerWidth,
      modalClose:false,
    validateRate:false,
    pathFile:process.env.VUE_APP_BASEURL_TICKET_FILE_POST,
    pathComment:process.env.VUE_APP_BASEURL_TICKET_FILE_COMMENT,
     items: [
          {
            text: 'Tickets',
            active: true,
            class:'cr-pointer',
            
          },
          {
            text:'Ticket no.',
            disabled:true
          },
      ],
      sumaryModal:false,
      reviewModal:false,
      conclusionModal:false,
      writeSumaryModal:false,
      mentorDetail:'',
        dataReview:{
          ticket:this.$route.params.id,
          reviewTo:'',
          typeSystem:'',
          reviewToName:'',
          review:{
            ticket:this.$route.params.id,
            category:'',
            reviewExport:'',
            title:'',
            detail:'',
            rating:0,
            reviewBy:'',
            reviewByName:'',
            reviewBySurname:'',
            anonymous:false
          }
        },
        yourRate:[],
        modalservice:false,
        loading:false,
        statusticket:null,
        optionstatus:[
  
            { value: 2, text: 'Answered' },
            { value: 3, text: 'Onhold' },
            { value: 4, text: 'Inprocess' },
          ],
        comment:[{
          id:1,
          img:'https://cdn1.iconfinder.com/data/icons/avatar-1-2/512/User2-512.png',
          title:'Posted by: Itengineer B1',
          status:'success',
          post:'we removed the server folder securrity right and reset it.. now folder is accesible and confirmed from user.(salesmgr1)',
          date:'27 May 2017 5:14 PM'
        },
        {
           id:2,
          img:'http://www.sclance.com/pngs/profile-icon-png/profile_icon_png_1113608.png',
          title:'Posted by: Itmgr1',
          status:'pending',
          post:'team, please check the server folder rights..',
          date:'27 May 2017 5:12 PM'
        },
        {
          id:3,
          img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThzNX6B2WbQS6m--WE7b-Evuu6Ks6FZu9_Yr8LuDmm9LizP_z_',
          title:'Posted by: Salesmgr 1',
          status:'pending',
          post:'server drive is still not accesible .. pls get this checked again..',
          date:'27 May 2017 5:10 PM'
        },
        {
          id:4,
          img:'https://png.pngtree.com/svg/20170602/b7c3ca6e9e.svg',
          title:'Posted by: Itengineer A1',
          status:'success',
          post:'server drive was not mapped.. so mapped it again on the users laptop server drive is now started working on laptop.',
          date:'27 May 2017 4:58 PM'
        }],
        comment:``,
        file:[
          { fileName : null }
        ],
        filemultisuccess:[],
        filecomment:null,
        filesuccess:'',
        detailall:'',
        typeOfBusiness:[],
        sumaryText:'',
        conclusionText:'',
        comapanyName:'',
        mentorName:''
      }
  },
  components:{
  },
  async created(){

    this.getTypeOfBusiness()
    await this.getdetailbyid() 
    this.checkReview()
    this.dataReview.review.typeSystem = this.user.typeSystem

  },
    computed: {
      ...mapState(["user"]),
    },
    methods:{
      checkComment(value){
        let filter = this.detailall.comments.filter(search =>{
          search.ownedBy == value
        })
        if(filter){
          return true
        }else{
          return false
        }
      },
      gopath(){
        this.$router.go('-1')
      },
      delFile(index){
        console.log('file before',this.file)
        this.file.splice(index,1)
        console.log(index)
        console.log('file after',this.file)
      },
      Addrate(rate,id,mentorId){
        let data ={
          ticketId:this.$route.params.id,
          commentId:id,
          rateTo:mentorId,
          rate:rate
        }
        console.log('Addrate',data)
        HTTPTICKET.post('/api/add/rate/comment',data).then(res => {
          console.log('/api/add/rate/comment',res)
          this.getdetailbyid() 
        })
      },
     async checkReview(){
        let data ={
          userId:this.user.userId,
          userLevel:this.user.userLevel,
          ticket:this.$route.params.id,
        }
        let review
        console.log('adsdsadasdasdasdsadsad',data)
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
       await HTTPTICKET.post('/api/company/get/ticket/not/review',data).then(res => {
          console.log('/api/company/get/ticket/not/review',res)
          review = res.data.data
        })
       let ck = this.detailall.comments.filter(se =>{
        return se.ownedBy != this.detailall.ownedPostBy
       })
       if(this.detailall.status == 6 && ck.length > 0 && this.detailall.mentorId != null){
            console.log('1')
            console.log(this.user.userLevel,this.user.userId,this.detailall.mentorId,review)
              if(this.user.userLevel == 50 && this.user.userId == this.detailall.mentorId && review == "not review"){
                console.log('3')
                this.reviewModal = true
              }else if(this.user.userLevel == 0 && this.user.userId == this.detailall.ownedPostBy && review == "not review"){
                console.log('4')
                this.modalservice = true
              }
          }
      },
      closeTicket(){
        this.dataReview={
          ticket:this.$route.params.id,
          reviewTo:'',
          reviewToName:'',
          typeSystem:this.user.typeSystem,
          review:{
            ticket:this.$route.params.id,
            category:'',
            title:'',
            reviewExport:'',
            detail:'',
            rating:0,
            reviewBy:'',
            reviewByName:'',
            reviewBySurname:'',
            anonymous:false,
            typeSystem:this.user.typeSystem
          }
        }
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTPTICKET.post('/api/close/ticket',{ticketId:this.$route.params.id}).then(result =>{
              console.log('/api/close/ticket',result)
              if(result.data.success){
                if(this.detailall.mentorId != null){
                  if(this.user.userLevel == 50){
                    let filter = this.detailall.comments.filter(search =>{
                      return search.ownedBy == this.detailall.mentorId
                    })
                    console.log('close',filter)
                    if(filter.length > 0){
                      this.reviewModal = true
                    }  
                  }else{
                    let filter = this.detailall.comments.filter(search =>{
                      return search.ownedBy == this.detailall.mentorId
                    })
                     console.log('close',filter)
                    if(filter.length > 0){
                      this.modalservice = true
                    }
                  }
                }
                
                this.getdetailbyid()
                //this.$router.push('/')
              }
            }).catch(e =>{
              console.log(e)
            })
      },
      addConclution(){
        let data = {
          ticketId:this.$route.params.id,
          summary:this.sumaryText
        }
        HTTPTICKET.post('/api/add/summary',data).then(res=>{
            if(res.data.success){
              this.getdetailbyid()
              this.writeSumaryModal = false
            }
        }).catch(e =>{
          console.log(e)
        })
      },
      reviewCompany(){
        if(this.dataReview.review.rating == 0){
          this.validateRate = true
        }else{
          this.dataReview.reviewTo = this.detailall.ownedPostBy
          this.dataReview.review.category = this.detailall.category
          this.dataReview.review.reviewExport = this.user.userIdExport
          this.dataReview.review.reviewBy = this.user.userId
          this.dataReview.review.reviewByName = this.user.name
          this.dataReview.review.reviewBySurname = this.user.surname
          this.dataReview.review.typeSystem = this.user.typeSystem
          console.log(this.dataReview)
            HTTPReview.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTPReview.post('/api/create/review',this.dataReview).then(res=>{
            console.log('/api/create/review',res)
            if(res.data.success){
              let data = {
                ticketId:this.$route.params.id,
                conclusion:this.conclusionText
              }
              HTTPTICKET.post('/api/add/conclusion',data).then(res=>{
                  if(res.data.success){
                    this.getdetailbyid()
                    this.reviewModal = false
                    this.dataReview={
                      ticket:this.$route.params.id,
                      reviewTo:'',
                      reviewToName:'',
                      review:{
                        ticket:this.$route.params.id,
                        category:'',
                        title:'',
                        detail:'',
                        reviewExport:'',
                        rating:0,
                        reviewBy:'',
                        reviewByName:'',
                        reviewBySurname:'',
                        anonymous:false
                      }
                    }
                  }
              }).catch(e =>{
                console.log(e)
              })
            }
            //this.$router.push('/review-detail')
          })
        }
      },
      getNameMentor(id){
        let name = ""
          var jwt = require('jsonwebtoken');
          var secret = '229Fb48BA38670B5BEC7cC5A3AB50E18F90cAEF78FAEF0F6D2A1CAE966B2B305'
          let user = {
            _id:id
          }
          var token = jwt.sign(user,secret, {
           expiresIn : '1d'
          });
          HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
          HTTPMentor.post('/api/get/data/user',{token:token}).then(res=>{
          console.log('/api/get/data/user',res)
            if(res.data.success){
              this.mentorName = res.data.obj.name+' '+res.data.obj.surname
            } 
          }) 
      },
      getNameCompany(id,type){
        let data
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
        HTTPTICKET.post('/api/get/user/by/id',{userId:id}).then(res=>{
          console.log('/api/get/user/by/id',res)
          if(res.data.success && res.data.obj.length > 0){
            this.comapanyName = res.data.obj[0]
          }
        }) 
      },
      getTypeOfBusiness(){
        HTTPTICKET.post('/api/get/type/of/business').then(res=>{
          if(res.data.success){
            res.data.obj.map(val =>{
              this.typeOfBusiness.push({value:val.id,text:val.name})
            })
          
          }
        })
      },
      checkstar(vaa){
        return vaa - 5
      },
      submitReview(){
        if(this.dataReview.review.rating == 0){
          this.validateRate = true
        }else{
          this.dataReview.reviewTo = this.detailall.mentorId
          this.dataReview.review.category = this.detailall.category
          this.dataReview.review.reviewBy = this.user.userId
          this.dataReview.review.reviewByName = this.user.name
          this.dataReview.review.reviewBySurname = this.user.surname
          this.dataReview.review.reviewExport = this.user.userIdExport
          console.log(this.dataReview)
          HTTPReview.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
          HTTPReview.post('/api/create/review',this.dataReview).then(res=>{
            console.log('/api/create/review',res)
            if(res.data.success){
              this.modalservice = false
              this.validateRate = false
            }
          })
        }
        
      },
      addmorefile(){
         this.file.push({fileName : null}) 
      }, 
      cancel(index){ 
        this.file.splice(index,1) 
      },
      errorcatch(){
      Swal.fire(
        'Error',
        'Please check your network connection',
        'error'
        )
      },
      async getdetailbyid(){
        this.$store.state.loadingdetail = true
        HTTPTICKET.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
       await HTTPTICKET.post(`/api/get/detail/ticket`,{ticketId:this.$route.params.id}).then(res => {
          if (res.data.success) {
            console.log('/api/get/detail/ticket',res)
            this.getNameCompany(res.data.obj.ownedPostBy)
            if(res.data.obj.mentorId != null){
               this.getNameMentor(res.data.obj.mentorId)
            }
           
            this.detailall = res.data.obj
            console.log('detailall',this.detailall)
            this.items[1].text = 'Ticket no. ' + this.detailall.ticketNo
            this.$store.state.loadingdetail = false
          }
        }).catch(e => {  
          this.errorcatch()
          this.$store.state.loadingdetail = false
          console.log("/api/get/detail/ticket/error",e);
        });
      },  
      uploadFile(event,index){
        let formData = new FormData();
        formData.append("file", event.target.files[0]);
        HTTPTICKET.post(`/upload/comment`,formData).then(res => {
          if (res.data.success) {
            this.file[index].fileName = res.data.obj
          }
        }).catch(e => {  
         this.errorcatch()
          this.loading = false
          console.log("/upload/comment/error",e);
        });
      },
      submit(){
        this.$validator.validate().then(result => {
          console.log('asdasdsadasd',result)
          if (result) {
            let status
            if(this.user.userLevel == 0){
              status = 5
            }else{
              status = this.statusticket
            }
            let data = {
              ticketId:this.$route.params.id,
              comment:{
                  profile:this.user.profilePic,
                  typeSystem:this.user.typeSystem,
                  message:this.comment,
                  userLevel:this.user.userLevel,
                  score:0,
                  name:this.user.name,
                  surname:this.user.surname,
                  commentFile:this.file
              },
              status:status
            }
            console.log(data)
            HTTPTICKET.post('/api/add/commment',data).then(res =>{
              console.log('/api/add/commment',res)
              if(res.data.success){
                this.comment = ''
                this.statusticket = null
                this.$validator.reset()
                console.log('error',)
                this.file = [{ fileName : null }]
                this.getdetailbyid()
              }
            }).catch(e => {  
              this.errorcatch()
              this.loading = false
              console.log("/api/add/commment/error",e);
            });
          }
        });
      },
      getProfilePic(type){
        let path = ''
        if(type == 'mentor'){
          path = process.env.VUE_APP_IMG_PROFILE_MENTOR
        }else if(type == 'inteGreat'){
          path = process.env.VUE_APP_IMG_PROFILE_INTEGREAT
        }else if(type == 'ticket'){
          path = process.env.VUE_APP_IMG_PROFILE_TICKET
        }
        return path
      },
      covertime(value){
        if (value) {
          var t = moment(value)
          return t.format("DD/MM/YYYY เวลา HH:mm น.");
        }
      },convertstatus(val){
        if(val == '0'){
          return 'Pending'
        }else if(val == '1'){
          return 'Inprocess'
        }else if(val == '2'){
          return 'Close'
        }else{
          return 'Other'
        }
      },
        formatNames(files) {
        if (files.length === 1) {
          return files[0].name
        } else {
          return `${files.length} files selected`
        }
      }
  },
  components:{
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$red:#E70000;
$grey :#C4C4C4;
$bggrey : #F3F3F3;
$CLOSED: #A6A6A6;
$OPEN: #0D6ACA;
$ONHOLD: #FD7900;
$COMPANY-REPLY: #0FB9F4;
$ANSWERED: #0ABA06;
$mentorpill : #0D6ACA;
$companypill:#FFA800;
$closeticket :#E70000;
$inprocress:#FFCB2A;


@media only screen and (max-width: 576px) {
  .pd-y-3{
    padding:1rem 0 1rem 0;
  }
  .fz-mobile{
    font-size: 1.5rem;
  }
  .tCenter{
    text-align: center;
  }
  .reply{
    width: 100%;
  }
  .closeticket{
    width: 100%;
  }
}

.reply{
    padding: 0.5rem 4rem;
    border-radius: 40px;
    border-color: transparent;
    background: linear-gradient(177.11deg, #2F8DFA -6.48%, #2F8DFA 92.69%);
}
.btn{
  border-radius: 30px;
}
.btn-secondary{
    background-color: white;
    border-color: white;
    border-radius: 30px;
}
.row{
  height: 100%;
}
.mentorpill{
  background: #0D6ACA;
}
.companypill{
  background: #FFA800;
}
.closeticket{
    padding: 0.5rem 4rem;
    border-radius: 40px;
    border-color: transparent;
    background: $closeticket;
}

.profilePic{
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  margin:0 auto;
  justify-content: center;
  align-items: center;
  background: #fff;
  background-color: #f8f9fa!important;
-webkit-box-shadow: 0px 2px 8px 0px rgba(196,196,196,1);
-moz-box-shadow: 0px 2px 8px 0px rgba(196,196,196,1);
box-shadow: 0px 2px 8px 0px rgba(196,196,196,1);
}
.profilePic img{
  
  max-width: 100%;
}

.orange{
  color: $ONHOLD;
}
.bgtopic{
  align-content: center;
  font-weight: 400;
  padding:1rem;
  text-align: center;
  background-color: #F7f7f7;
  box-shadow: 0 0 0 1px #DADADA;
  border-radius: 5px;
}
.red{
  color: $red;
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6{
  line-height: 0.9;
}
.bgblue{
  background:$COMPANY-REPLY;
}
.bgorange{
  background: $ONHOLD
}
.grey{
  color: #7D7D7D;
}
.detail{
  box-shadow: 0 0 0 1px #C4C4C4;
  background: white;
  border-radius: 5px;
  
}
.bgowner{
  background: #F7FBFF
}
.status-close{

}.CLOSED{
  border-color: $red;
  white-space: nowrap;
  background-image: linear-gradient($red, $red);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   

}
.OPEN{
  border-color: $OPEN;
  background-image: linear-gradient($OPEN, $OPEN);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ONHOLD{
   border-color: $ONHOLD;
  background-image: linear-gradient($ONHOLD, $ONHOLD);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.COMPANY-REPLY{
  border-color: $COMPANY-REPLY;
  background-image: linear-gradient($COMPANY-REPLY, $COMPANY-REPLY);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ANSWERED{
    border-color: $ANSWERED;
  background-image: linear-gradient($ANSWERED, $ANSWERED);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
    white-space: nowrap;
}

.inprocress{
    border-color: $inprocress;
  background-image: linear-gradient($inprocress, $inprocress);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
    white-space: nowrap;
}


.w-100{
  widows: 100%;
}
.opacity-commet{
  opacity: 0.5;
}

.radius-top{
  border-top-left-radius: 3px!important;
  border-top-right-radius: 3px!important;
}
.radius-top-none{
  border-top-left-radius: 0px!important;
  border-top-right-radius: 0px!important;
}
.radius-btn{
  border-top-left-radius:3px!important;
}
.hearder-middle{
  display: flex;
  align-items: center;
  justify-content: center
}
.is-validate{
  border-color: #dc3545;
  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);

}
button:not(:disabled){
  cursor: default;
}
a:hover{
  text-decoration: none!important;
  color: #007bff!important;
  cursor: default!important;
}
.breadcrumb-item.active{
  cursor: pointer!important;
  
}
.breadcrumb{
background-color: white!important;
}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue